/**
 * URL detection helpers.
 *
 * `extractUrls` returns URLs that appear in plain text — it does NOT scan inside
 * fenced code blocks or inline code spans, mirroring how Slack/WhatsApp render
 * unfenced links without breaking on `https://example.com` written in a code
 * snippet.
 */

const URL_REGEX = /\bhttps?:\/\/[^\s<>"')\]]+/gi;

export function extractUrls(text: string): string[] {
  if (!text) return [];
  // Mask code regions so we don't extract URLs from them.
  const masked = text
    .replace(/```[\s\S]*?```/g, (m) => ' '.repeat(m.length))
    .replace(/`[^`\n]*`/g, (m) => ' '.repeat(m.length));
  const matches = masked.match(URL_REGEX) ?? [];
  // Trim trailing punctuation that is rarely part of the URL.
  return Array.from(new Set(matches.map((u) => u.replace(/[.,!?;:]+$/, ''))));
}

export function isUrl(s: string): boolean {
  return /^https?:\/\//i.test(s);
}
